import React from "react";

export default ({ value: { baseId, apiKey }, onChange, onSubmit }) => {
  const apiKeyValid = /^key[A-Za-z0-9]+$/.test(apiKey);
  const baseIdValid = /^app[A-Za-z0-9]+$/.test(baseId);
  const disabled = !apiKeyValid || !baseIdValid;

  return (
    <div className="w-full max-w-xs mx-auto">
      <form
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
        onSubmit={e => {
          e.preventDefault();
          if (disabled) return;
          onSubmit();
        }}
      >
        <div className="mb-4">
          <label
            className="block text-grey-700 text-sm font-bold mb-2"
            htmlFor="apiKey"
          >
            Airtable API key
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-grey-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
            id="apiKey"
            type="apiKey"
            placeholder="keyEyUQnDu83jKnDa"
            value={apiKey || ""}
            onChange={e => onChange({ baseId, apiKey: e.target.value })}
          />
          {apiKeyValid || !apiKey || apiKey.length === 0 || (
            <p className="text-xs italic">
              Hmm, this doesn't look like an API key. It should start with "key"
            </p>
          )}
        </div>
        <div className="mb-6">
          <label
            className="block text-grey-700 text-sm font-bold mb-2"
            htmlFor="baseId"
          >
            Airtable Base ID
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-grey-700 leading-tight focus:outline-none focus:shadow-outline"
            id="baseId"
            type="text"
            placeholder="appY9ZEL3jdKaueNq9"
            value={baseId || ""}
            onChange={e => onChange({ baseId: e.target.value, apiKey })}
          />
          {baseIdValid || !baseId || baseId.length === 0 || (
            <p className="text-xs italic mt-2">
              Hmm, this doesn't look like a Base ID. It should start with "app"
            </p>
          )}
        </div>
        <div className="flex items-center justify-between">
          <button
            className={`text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
              disabled
                ? "bg-grey cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
            type="submit"
            disabled={disabled}
          >
            Save
          </button>
        </div>
      </form>
      <p className="text-center text-grey text-xs">
        ©2019 Genco Cocoa Corp. Some rights reserved.
      </p>
    </div>
  );
};
